const formatName = (name) => {
    if (name !== null) {
        let words = name.split('_');
        let newName = words.join(' ');
        return newName.toUpperCase();
    }
};

export default formatName;
